import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { getCurrentAuthenticatedUser } from '@edge/spark/io-aws'
import { formatName } from '@edge/spark/utils'
import { env } from '@edge/env'
import { getActiveAuctionId } from '@edge/spark/io-roles'

const apiKey = env.REACT_APP_BUGSNAG_API_KEY
const releaseStage = env.REACT_APP_BUGSNAG_ENV
const buildNumber = env.REACT_APP_BUILD_NUMBER
const branch = env.REACT_APP_BRANCH_NAME

const appVersion = `${branch}#${buildNumber}`

export const bugsnagClient =
    apiKey && releaseStage
        ? Bugsnag.start({
              apiKey,
              plugins: [new BugsnagPluginReact()],
              appVersion,
              releaseStage,
              enabledReleaseStages: ['dev-react', 'stage-react', 'prod-sparkpreview'],
              onError: async (event) => {
                  const user = await getCurrentAuthenticatedUser()
                  const auction = await getActiveAuctionId()
                  const username = user?.username
                  const email = user?.email
                  const name = formatName({ firstName: user?.name, lastName: user?.familyName })
                  event.setUser(username, email, name)
                  event.addMetadata('auction', { auction })
                  event.addMetadata('localStorage', { ...localStorage })
              },
          })
        : null

export const BugsnagErrorBoundary = (apiKey && Bugsnag.getPlugin('react')?.createErrorBoundary(React)) || React.Fragment
